var React = require('react');

function InlineSvg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 1L13 13","stroke":"black","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M13 1L1 13","stroke":"black","strokeWidth":"2","key":1})]);
}

InlineSvg.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = InlineSvg;

InlineSvg.default = InlineSvg;
